import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { isDemoEnvironment } from '../../../constants/global';
import { handleGql403 } from '../../../utils';
import { LineItemQuickAction, MutationQuickActionLineItemByIdArgs, QuickActionLineItemByIdMutation } from '../types';
import { QUICK_ACTION_LINE_ITEM_BY_ID } from './quickActionLineItemByID';

type QuickActionLineItemByID = {
  id: string;
};

export type UseQuickActionLineItemByID = {
  handleQuickActionLineItemByID: (
    lineItemId: string,
    action: LineItemQuickAction
  ) => Promise<QuickActionLineItemByID | undefined>;
  loading: boolean;
};

const useQuickActionLineItemByID = (): UseQuickActionLineItemByID => {
  const [quickActionLineItemByID, { loading }] = useMutation<
    QuickActionLineItemByIdMutation,
    MutationQuickActionLineItemByIdArgs
  >(QUICK_ACTION_LINE_ITEM_BY_ID, {
    onError: handleGql403,
  });

  const handleQuickActionLineItemByID = useCallback(
    async (lineItemId: string, action: LineItemQuickAction) => {
      if (isDemoEnvironment) {
        return Promise.resolve({ id: '' });
      }

      const { data } = await quickActionLineItemByID({
        variables: {
          lineItemId,
          action,
        },
      });

      return data?.quickActionLineItemByID;
    },
    [quickActionLineItemByID]
  );

  return {
    handleQuickActionLineItemByID,
    loading,
  };
};

export default useQuickActionLineItemByID;
